
/**
 * Module dependencies.
 */

import { createAction } from 'redux-actions'
import fetch from 'lib/fetch'
import qs from 'qs'

/**
 * Types.
 */

export const CREATING_SESSION = 'CREATING_SESSION'
export const CREATE_SESSION_INVALID_PASSWORD = 'CREATE_SESSION_INVALID_PASSWORD'
export const CREATE_SESSION_INVALID_EMAIL = 'CREATE_SESSION_INVALID_EMAIL'
export const CREATE_SESSION_ERROR = 'CREATE_SESSION_ERROR'
export const CREATED_SESSION = 'CREATED_SESSION'

/**
 * Actions.
 */

const creatingSession = createAction(CREATING_SESSION)
const createSessionInvalidPassword = createAction(CREATE_SESSION_INVALID_PASSWORD)
const createSessionInvalidEmail = createAction(CREATE_SESSION_INVALID_EMAIL)
const createSessionError = createAction(CREATE_SESSION_ERROR)
const createdSession = () => dispatch => {
  dispatch({ type: CREATED_SESSION })
  const search = window.location.search.substr(1)
  const { redirect } = qs.parse(search)
  const { destination } = window.segment // TODO: move to redux
  if (redirect) {
    window.location = redirect
  } else if (destination) {
    window.location = destination
  } else {
    // TODO: once everything has been merged, we should just be able to `navigate` here
    window.location = '/workspaces'
  }
}

/**
 * Create a new session with `email` and `password`.
 */

export function createSession ({ email, password }) {
  return function (dispatch) {
    dispatch(creatingSession({ email, password }))

    fetch('/api/session', {
      method: 'POST',
      body: JSON.stringify({ email, password })
    })
    .then(res => {
      const { ok, status } = res

      if (ok) {
        res.json().then(identifyUser)
        dispatch(createdSession())
      } else if (status === 401) {
        dispatch(createSessionInvalidPassword())
      } else if (status === 404) {
        dispatch(createSessionInvalidEmail())
      } else {
        throw new Error(`Unknown session error: ${status}`)
      }
    })
    .catch(error => {
      dispatch(createSessionError({ error }))
    })
  }
}

function identifyUser (user) {
   // analytics
   // https://segment.atlassian.net/browse/INT-581
   // Workaround an unexpected behavior in `analytics.js` where changing userId
   // via `identify` also changes the `anonymousId`, which breaks our ability to link
   // userIds together via anonymousId (needed due to userId reservation).
   // This hacks around that behavior by saving anonymousId to a local variable,
   // call `identify`, then set the anonymousId back to the original anonymousId prior to calling `identify`.
  let anonymousId = null
   // We also need to protect against `window.analytics.user` is not a function
   // Not sure why needed, but see https://github.com/segmentio/app/pull/2206/files#r74857096
  if (typeof window.analytics.user === 'function') {
    anonymousId = window.analytics.user().anonymousId()
  }
  window.analytics.identify(user.id, {
    created: user.created,
    name: user.name,
    email: user.email
  })
  if (anonymousId) {
    window.analytics.user().anonymousId(anonymousId)
  }
  window.analytics.track('User Logged In')
}



// WEBPACK FOOTER //
// ./actions/session.js